import { render, staticRenderFns } from "./showPos.vue?vue&type=template&id=13c1535a"
import script from "./showPos.vue?vue&type=script&lang=js"
export * from "./showPos.vue?vue&type=script&lang=js"
import style0 from "./showPos.vue?vue&type=style&index=0&id=13c1535a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports